// @flow

import React from 'react';
import { observer } from 'mobx-react';

import type { User } from '~/types';

import ContributorList from '~/components/global/ContributorList';
import Title from '~/components/global/Title';

@observer
export default class Staff extends React.Component {
    props: {
        contributors: Array<User>,
    };

    render() {
        return (
            <div>
                <h4>
                    <Title boldText={ 'STAFF' } />
                </h4>

                <ContributorList
                    anchor
                    contributors={ this.props.contributors }
                    displayDetails
                    full
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/Staff.js